import { render } from "./scanzy.vue?vue&type=template&id=a68fedf0"
import script from "./scanzy.vue?vue&type=script&lang=js"
export * from "./scanzy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__